'use client';

import React, { useRef, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { useApolloClient } from '@apollo/client';

import { makeStore, AppStore } from '@lib/redux/store';

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const apolloClient = useApolloClient();

  const storeRef = useRef<AppStore | undefined>(undefined);
  if (!storeRef.current) {
    storeRef.current = makeStore({ apolloClient });
  }

  useEffect(() => {
    const toastrRoot = document.getElementById('toastr-root');
    if (toastrRoot) {
      const root = createRoot(toastrRoot);
      root.render(
        <Provider store={storeRef.current}>
          <ReduxToastr
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            closeOnToastrClick
          />
        </Provider>,
      );

      return () => {
        root.unmount();
      };
    }
  }, []);

  return <Provider store={storeRef.current}>{children}</Provider>;
}
